import type { SVGProps } from "react";

type SwatchBookIconProps = SVGProps<SVGSVGElement> & {
  size?: number | string;
  strokeWidth?: number | string;
};

/**
 * Approved "swatch book" Materials icon (sandbox option B).
 * Local copy — not dependent on the installed lucide-react version.
 */
export function SwatchBookIcon({
  className,
  size = 24,
  strokeWidth = 2,
  ...rest
}: SwatchBookIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...rest}
    >
      <path d="M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z" />
      <path d="M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7" />
      <path d="M7 17h.01" />
      <path d="m11 8 2.3-2.3a2.4 2.4 0 0 1 3.4 0L18.6 7.6a2.4 2.4 0 0 1 0 3.4L9.9 19.8" />
    </svg>
  );
}
